import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EditSubCategoryService {

  constructor(private _http: HttpClient) { }

  getcategory(data) {
    return this._http.post(environment.api_url+'getcategory',data);
  }

  updatecategory(data) {
    return this._http.post(environment.api_url+'updatecategory',data);
  }

  deletecategoryimage(data) {
    return this._http.post(environment.api_url+'deletecategoryimage',data);
  }

  searchcategory(data) {
    return this._http.post(environment.api_url+'searchcategory',data);
  }

}
